// Texts of the web app. French is the reference; the English object must
// have exactly the same keys (checked by TypeScript).
// Most texts are shared with the iOS app (App/Localization/Strings*.swift).

export interface KeyPoint {
  icon: 'key' | 'warning' | 'undo' | 'chart' | 'shield' | 'person' | 'hand';
  title: string;
  detail: string;
}

export const fr = {
  ok: "OK",
  cancel: "Annuler",
  done: "Terminé",
  save: "Enregistrer",
  delete: "Supprimer",
  later: "Plus tard",
  copy: "Copier",
  copied: "Copié",
  share: "Partager",
  paste: "Coller",
  clear: "Effacer",
  continueButton: "Continuer",
  now: "maintenant",
  today: "Aujourd'hui",
  yesterday: "Hier",
  language: "Langue",
  languageTitle: "Choisis ta langue",
  languageSubtitle: "Tu pourras la changer en tout temps dans Paramètres.",
  legalTitle: "Avant de commencer",
  legalSubtitle: "Lis ces points importants. Ils protègent ton argent.",
  legalUpdatedTitle: "Nos conditions ont changé",
  legalUpdatedSubtitle: "Lis les changements et accepte-les pour continuer à utiliser COINWOW.",
  legalWhatChanged: "Ce qui change",
  legalUpdateSummary: "Version 1.1 : les conditions couvrent maintenant l'app Android (Google Play) et expliquent comment ta phrase est protégée sur Android. Rien ne change pour l'iPhone et le Web.",
  legalReadFull: "Lire le document complet",
  legalCheckAge: "J'ai l'âge de la majorité là où je vis (18 ans au Québec).",
  legalCheckRisk: "Je comprends que si je perds ma phrase de récupération, mes CW sont perdus pour toujours, que les envois sont irréversibles et que COINWOW ne garantit aucun profit.",
  legalCheckTerms: "J'ai lu et j'accepte les conditions d'utilisation, l'avis sur les risques et la politique de confidentialité.",
  legalAcceptButton: "Accepter et continuer",
  legalDocumentTitle: "Conditions et confidentialité",
  welcomeTagline: "Ton wallet CW.\nTes clés restent sur ton téléphone.",
  createWallet: "Créer un wallet",
  haveWallet: "J'ai déjà un wallet",
  restoreTitle: "Restaurer",
  restoreHeader: "Tes 12 ou 24 mots, séparés par des espaces",
  restoreSuggestions: "Suggestions",
  restoreButton: "Restaurer mon wallet",
  restoreFooter: "Tes mots restent sur ton téléphone. Ils ne sont jamais envoyés à COINWOW.",
  restoreBadChecksum: "Ces mots ne forment pas une phrase valide. Vérifie l'ordre et chaque mot.",
  restoreInvalid: "Phrase invalide.",
  backupIntroTitle: "Sauvegarde ta phrase de récupération",
  backupShowWords: "Afficher mes 12 mots",
  backupWordsTitle: "Tes 12 mots",
  backupWordsSubtitle: "Écris-les sur papier, dans cet ordre exact.",
  backupNoScreenshot: "Pas de capture d'écran : une photo peut être volée ou synchronisée en ligne.",
  backupWroteThem: "Je les ai écrits",
  backupScreenshotTitle: "Capture d'écran détectée",
  backupScreenshotMessage: "Pour ta sécurité, supprime cette capture de tes Photos et note plutôt tes mots sur papier.",
  backupVerifyTitle: "Vérifions ta sauvegarde",
  backupWrongWord: "Ce n'est pas le bon mot. Vérifie ta feuille.",
  backupSeeWordsAgain: "Revoir mes mots",
  backupDoneTitle: "Sauvegarde confirmée",
  backupDoneText: "Garde ta feuille en lieu sûr. C'est la seule façon de récupérer tes CW si tu perds ton téléphone.",
  backupReminderTitle: "Sauvegarde ta phrase",
  backupReminderText: "Sans tes 12 mots, tu perds tes CW si tu perds ton téléphone.",
  backupSettingsRow: "Sauvegarde des 12 mots",
  fileBackupRow: "Sauvegarde chiffrée (fichier)",
  fileBackupTitle: "Sauvegarde chiffrée",
  fileBackupIntro: "Crée un fichier qui contient tes 12 mots, chiffré avec un mot de passe que tu choisis. Tu peux le garder dans iCloud Drive, Google Drive ou sur une clé USB, puis le restaurer sur n'importe quel appareil COINWOW.",
  fileBackupWarning: "Personne ne peut retrouver ce mot de passe, ni COINWOW ni ton fournisseur. Si tu l'oublies, le fichier est inutilisable : garde aussi ta copie papier.",
  fileBackupPassword: "Mot de passe de la sauvegarde",
  fileBackupConfirm: "Confirme le mot de passe",
  fileBackupTooShort: "Au moins 10 caractères. Une phrase de passe fonctionne très bien.",
  fileBackupMismatch: "Les deux mots de passe ne sont pas identiques.",
  fileBackupCreate: "Créer le fichier",
  fileBackupWorking: "Chiffrement…",
  fileBackupDone: "Fichier créé. Garde-le en lieu sûr et note ton mot de passe ailleurs.",
  fileBackupRestoreRow: "Restaurer depuis un fichier chiffré",
  fileBackupChoose: "Choisir le fichier de sauvegarde",
  fileBackupRestore: "Restaurer depuis le fichier",
  fileBackupErrNot: "Ce fichier n'est pas une sauvegarde COINWOW.",
  fileBackupErrUnsupported: "Cette sauvegarde vient d'une version que cette app ne reconnaît pas.",
  fileBackupErrNetwork: "Cette sauvegarde est pour un autre réseau.",
  fileBackupErrPassword: "Mot de passe incorrect, ou fichier modifié.",
  fileBackupErrPhrase: "Le fichier est déchiffré, mais la phrase qu'il contient est invalide.",
  backupStatusDone: "Faite",
  backupStatusTodo: "À faire",
  tabWallet: "Portefeuille",
  activity: "Activité",
  scan: "Scanner",
  settings: "Paramètres",
  totalBalance: "Solde total",
  showBalance: "Afficher le solde",
  hideBalance: "Masquer le solde",
  send: "Envoyer",
  receive: "Recevoir",
  latestTransactions: "Dernières transactions",
  noTransactions: "Aucune transaction pour l'instant.",
  seeAll: "Voir tout",
  myAddress: "Mon adresse",
  copyAddress: "Copier l'adresse",
  received: "Reçu",
  sent: "Envoyé",
  pending: "En attente",
  confirmed: "Confirmée",
  receiveTitle: "Recevoir des CW",
  receiveOnlyCW: "Envoie seulement des CW (COINWOW) à cette adresse.",
  receiveNewAddress: "Une nouvelle adresse apparaît après chaque paiement reçu, pour protéger ta vie privée. Les anciennes restent valides.",
  qrLabel: "Code QR de l'adresse",
  transaction: "Transaction",
  status: "Statut",
  date: "Date",
  block: "Bloc",
  networkFee: "Frais du réseau",
  subtractFee: "Soustraire les frais du montant",
  transactionID: "Identifiant de transaction",
  sendTitle: "Envoyer des CW",
  to: "À",
  addressPlaceholder: "Adresse cw1…",
  addressInvalid: "Ce n'est pas une adresse COINWOW valide. Une adresse CW commence par « cw1 ».",
  addressAmountInvalid: "Le montant dans ce code est invalide.",
  addressUnsupported: "Ce code de paiement demande une option que COINWOW ne gère pas.",
  ownAddressWarning: "C'est une adresse de ton propre wallet.",
  scanQR: "Scanner un code QR",
  amount: "Montant",
  amountInvalid: "Montant invalide (8 décimales maximum).",
  fees: "Frais",
  speed: "Vitesse",
  feeSlow: "Économique",
  feeNormal: "Normal",
  feeFast: "Rapide",
  feesFooter: "Les frais vont aux mineurs du réseau COINWOW, pas à l'app.",
  reviewSend: "Vérifier l'envoi",
  review: "Vérifier",
  youSend: "Tu envoies",
  totalDebited: "Total débité",
  irreversibleWarning: "Vérifie bien l'adresse. Un envoi sur la blockchain ne peut pas être annulé.",
  confirmSend: "Confirmer l'envoi",
  sentTitle: "Envoyé",
  copyTxid: "Copier l'identifiant de transaction",
  txidCopied: "Identifiant copié",
  addToContacts: "Ajouter aux contacts",
  scanTitle: "Scanner",
  scanHint: "Vise le code QR d'une adresse COINWOW",
  scanNoCamera: "Aucune caméra disponible sur cet appareil. Colle l'adresse dans l'écran Envoyer.",
  scanNotCoinwow: "Ce code QR ne contient pas une adresse COINWOW.",
  openSettings: "Ouvrir les Réglages",
  contactsTitle: "Contacts",
  contactsEmpty: "Aucun contact. Ajoute tes amis pour ne plus avoir à retaper leur adresse.",
  contactsSearch: "Rechercher",
  contactAdd: "Ajouter un contact",
  contactNew: "Nouveau contact",
  contactEdit: "Modifier le contact",
  contactName: "Nom",
  contactNamePlaceholder: "Nom du contact",
  contactAddress: "Adresse COINWOW",
  contactDelete: "Supprimer le contact",
  securityBackup: "Sécurité",
  showPhrase: "Afficher ma phrase de récupération",
  hidePhrase: "Masquer la phrase",
  phraseWarning: "Écris ces mots sur papier, dans l'ordre. Quiconque les voit peut prendre tes CW.",
  network: "Réseau",
  server: "Serveur",
  about: "À propos",
  version: "Version",
  deleteWallet: "Supprimer le wallet de cet appareil",
  deleteWalletFooter: "Tes CW restent sur la blockchain. Tu pourras les récupérer seulement avec tes 12 mots.",
  deleteWalletConfirm: "Sans ta phrase de 12 mots, tu ne pourras pas récupérer tes CW.",
  authShowPhrase: "Afficher ta phrase de récupération",
  authDeleteWallet: "Supprimer le wallet de cet appareil",
  usePasscode: "Utiliser le code",
  authUnlock: "Déverrouiller COINWOW",
  unlock: "Déverrouiller",
  notifPendingBody: "Le paiement est en route et sera confirmé au prochain bloc.",
  notifConfirmedBody: "Le paiement est confirmé.",
  rateLimited: "Trop de requêtes. Réessaie dans quelques secondes.",
  invalidResponse: "Réponse inattendue du serveur COINWOW.",
  inconsistentData: "Le serveur a renvoyé des données incohérentes. Par sécurité, rien n'a été affiché.",
  genericError: "Une erreur est survenue. Réessaie.",
  legalAcceptedOn: (date: string) => `Accepté sur cet appareil le ${date}.`,
  restoreWordCount: (n: number) => n <= 1 ? `${n} mot` : `${n} mots`,
  restoreUnknownWord: (word: string) => `« ${word} » n'est pas un mot de la liste. Vérifie l'orthographe.`,
  restoreBadCount: (n: number) => `Il faut 12 ou 24 mots (tu en as ${n}).`,
  backupVerifySubtitle: (current: number, total: number) => `Choisis le bon mot selon ta feuille (${current} sur ${total}).`,
  backupWordNumber: (n: number) => `Mot nº ${n}`,
  pendingAmount: (amount: string) => `${amount} en attente`,
  confirmations: (n: number) => n > 1 ? `Confirmée (${n} confirmations)` : `Confirmée (${n} confirmation)`,
  available: (amount: string) => `Disponible : ${amount}`,
  sentText: (amount: string) => `${amount} sont en route. Ils seront confirmés au prochain bloc.`,
  contactDeleteConfirm: (name: string) => `Supprimer « ${name} » de tes contacts?`,
  contactDuplicate: (name: string) => `Cette adresse est déjà enregistrée pour « ${name} ».`,
  authSend: (amount: string) => `Confirmer l'envoi de ${amount}`,
  notifReceivedTitle: (amount: string) => `Tu as reçu ${amount}`,
  txRejected: (reason: string) => `Transaction refusée par le réseau : ${reason}`,
  serverError: (status: number) => `Erreur du serveur COINWOW (${status}). Réessaie plus tard.`,
  offline: (detail: string) => `Impossible de joindre le serveur COINWOW. Vérifie ta connexion Internet. (${detail})`,
  amountBelowDust: (minimum: string) => `Montant trop petit. Minimum : ${minimum}.`,
  insufficientFunds: (needed: string, available: string) => `Solde insuffisant : il faut ${needed} avec les frais, tu as ${available}.`,
  feeTooHigh: (fee: string) => `Frais anormalement élevés (${fee}). Envoi bloqué par sécurité.`,
  legalKeyPoints: [
    { icon: 'key', title: 'Toi seul contrôles tes CW', detail: "COINWOW est un portefeuille non gardien. Nous n'avons jamais accès à tes fonds et ne pouvons ni les bloquer, ni les récupérer." },
    { icon: 'warning', title: 'Perdre ta phrase = perdre tes CW', detail: 'Tes 12 mots sont la seule clé de ton portefeuille. Sans eux, personne ne peut récupérer tes CW, même pas nous.' },
    { icon: 'undo', title: 'Les envois sont irréversibles', detail: "Un envoi confirmé ne peut pas être annulé. Vérifie toujours l'adresse et le montant." },
    { icon: 'chart', title: 'Aucune garantie de profit', detail: 'Le CW est une cryptomonnaie expérimentale, pas un placement. Sa valeur peut tomber à zéro. COINWOW ne te rendra pas riche.' },
    { icon: 'shield', title: 'On ne te demandera jamais tes 12 mots', detail: 'Toute personne qui te les demande, même au nom de COINWOW, essaie de te voler. Méfie-toi des faux sites et des arnaques.' },
    { icon: 'person', title: 'Réservé aux personnes majeures', detail: "Tu dois avoir l'âge de la majorité là où tu vis (18 ans au Québec) et respecter les lois de ton pays, y compris en matière d'impôts." },
    { icon: 'hand', title: 'Ta vie privée', detail: 'Aucun nom, courriel ni téléphone demandé. Aucune publicité, aucun pistage. La blockchain, elle, est publique.' },
  ] as KeyPoint[],
  backupIntroPoints: [
    "Tu vas voir 12 mots. Écris-les sur papier, dans l'ordre.",
    "Avec ces mots, tu récupères tes CW sur n'importe quel appareil.",
    'Garde le papier en lieu sûr. Ne le photographie pas et ne le partage avec personne.',
    "Sur le Web, ton navigateur peut effacer ses données : ta feuille est ta seule vraie sauvegarde.",
  ],

  // --- Web ---
  iCloudFooter: "Ta phrase est chiffrée avec ton code et reste seulement dans ce navigateur. Elle n'est sauvegardée nulle part ailleurs : garde ta copie papier.",
  scanCameraDenied: "COINWOW n'a pas accès à la caméra. Autorise-la dans les réglages de ton navigateur, puis réessaie.",
  keychainError: (status: number) => `Erreur de stockage (${status}).`,
  backupMandatoryNote: "Sur le Web, cette étape est obligatoire : ton navigateur peut effacer ses données sans prévenir.",
  pinCreateTitle: 'Choisis un code',
  pinCreateSubtitle: "6 chiffres pour ouvrir COINWOW et confirmer tes envois. Il chiffre ta phrase sur cet appareil.",
  pinConfirmTitle: 'Confirme ton code',
  pinMismatch: 'Les deux codes ne sont pas pareils. Recommence.',
  pinWeak: 'Code trop simple. Évite 000000, 123456 et les suites.',
  pinEnterTitle: 'Entre ton code',
  pinWrong: (left: number) => left > 0 ? `Code incorrect. Encore ${left} essai${left > 1 ? 's' : ''} avant une pause.` : 'Code incorrect.',
  pinLocked: (seconds: number) => `Trop d'essais. Réessaie dans ${seconds} s.`,
  pinForgot: 'Code oublié ?',
  pinForgotText: "Sans ton code, la seule façon de retrouver tes CW est ta phrase de 12 mots : supprime le wallet de ce navigateur, puis restaure-le avec ta phrase et choisis un nouveau code.",
  pinReset: 'Supprimer et restaurer',
  confirmWithPin: 'Confirme avec ton code',
  unlockFaceID: 'Utiliser Face ID',
  faceIDOfferTitle: 'Ouvrir COINWOW avec Face ID ?',
  faceIDOfferText: "Plus rapide que ton code. Ton code reste utilisable en tout temps, et Face ID ne quitte jamais ton appareil.",
  faceIDOfferButton: 'Activer Face ID',
  faceIDConfirm: 'Confirmer avec Face ID',
  faceIDRow: 'Face ID / Touch ID',
  faceIDFooter: "Déverrouille avec Face ID ou Touch ID grâce à une clé d'accès (passkey). Ton code reste toujours utilisable.",
  faceIDUnsupported: "Pas disponible dans ce navigateur. Ajoute COINWOW à ton écran d'accueil sur un appareil récent.",
  faceIDFailed: "Face ID n'a pas fonctionné. Utilise ton code.",
  enable: 'Activer',
  disable: 'Désactiver',
  installTitle: "Ajoute COINWOW à ton écran d'accueil",
  installText: "COINWOW s'ouvre alors comme une vraie app, en plein écran, et ton navigateur garde mieux tes données.",
  installStepsIOS: ["Touche le bouton Partager (le carré avec une flèche) dans Safari.", "Choisis « Sur l'écran d'accueil ».", 'Touche « Ajouter ».'],
  installStepsOther: ["Ouvre le menu de ton navigateur (⋮).", "Choisis « Installer l'application » ou « Ajouter à l'écran d'accueil »."],
  installFirstTitle: 'Installe COINWOW comme une app',
  installFirstText: 'Ajoute COINWOW à ton écran d’accueil avant de commencer : l’app s’ouvre en plein écran, avec Face ID, et ton wallet reste au même endroit.',
  installIPhoneTitle: 'iPhone (Safari)',
  installIPhoneSteps: ['Ouvre app.coinwow.ca dans Safari.', 'Touche le bouton Partager (le carré avec une flèche). Sur iOS 26, il est dans le menu ⋯ à côté de l’adresse.', 'Choisis « Sur l’écran d’accueil », puis « Ajouter ».', 'Ouvre COINWOW depuis ton écran d’accueil et crée ton wallet là.'],
  installAndroidTitle: 'Android (Chrome)',
  installAndroidSteps: ['Ouvre app.coinwow.ca dans Chrome.', 'Touche le menu ⋮ en haut à droite.', 'Choisis « Installer l’application » ou « Ajouter à l’écran d’accueil », puis confirme.', 'Ouvre COINWOW depuis ton écran d’accueil.'],
  installNow: 'Installer maintenant',
  installLater: 'Continuer dans le navigateur',
  installIOSNote: "Sur iPhone, fais-le avant de créer ou restaurer ton wallet : l'app de l'écran d'accueil a son propre espace, séparé de Safari.",
  installRow: "Installer sur l'écran d'accueil",
  notifications: 'Notifications',
  notificationsRow: 'Me prévenir quand je reçois des CW',
  notificationsFooter: "Fonctionne pendant que COINWOW est ouvert. Sur iPhone, ajoute d'abord COINWOW à ton écran d'accueil (iOS 16.4 ou plus).",
  notificationsDenied: 'Notifications refusées dans les réglages du navigateur.',
  exportCoreRow: 'Exporter vers COINWOW Core',
  exportCoreTitle: 'Exporter vers COINWOW Core',
  exportCoreText: "Pour retrouver tes CW sans nos serveurs, colle ces deux commandes dans la console de COINWOW Core (Fenêtre → Console), dans un wallet vide créé pour l'occasion.",
  exportCoreWarning: 'Ces lignes contiennent ta clé privée : quiconque les voit peut prendre tes CW. Ne les partage jamais.',
  copyCommand: 'Copier la commande',
  storageWarning: "Ce navigateur peut effacer les données de COINWOW. Garde ta phrase de 12 mots sur papier.",
  webWarningsTitle: 'À savoir',
  webWarningsIntro: 'COINWOW Web garde ton wallet seulement dans ce navigateur, sur cet appareil. Lis ces points avant d’y mettre de l’argent.',
  webWarningsRow: 'À savoir sur l’app Web',
  webWarningsAccept: 'J’ai compris',
  webWarnings: [
    { icon: 'key', title: 'Tes 12 mots sont ta seule sauvegarde', detail: 'Le wallet est seulement dans ce navigateur. Si tu effaces l’historique de Safari, changes de téléphone ou supprimes l’app de l’écran d’accueil, il disparaît. Sans tes 12 mots sur papier, tes CW sont perdus pour toujours.' },
    { icon: 'warning', title: 'Sur iPhone : Safari et l’écran d’accueil sont séparés', detail: 'L’app ajoutée à l’écran d’accueil a son propre stockage. Un wallet créé dans Safari n’y apparaît pas (et l’inverse) : restaure-le avec tes 12 mots.' },
    { icon: 'shield', title: 'Choisis un code difficile', detail: 'Ton wallet est chiffré par ton code. Quelqu’un qui copie les données de ton appareil pourrait essayer de le deviner : évite 123456, ta date de naissance ou un code que tu utilises ailleurs.' },
    { icon: 'chart', title: 'Garde des petits montants', detail: 'Un navigateur est moins protégé qu’une app installée ou qu’un ordinateur hors ligne. Pour de grosses sommes, utilise COINWOW Core.' },
    { icon: 'person', title: 'Méfie-toi des faux sites', detail: 'La seule adresse officielle est app.coinwow.ca. Personne de COINWOW ne te demandera jamais tes 12 mots ni ton code.' },
    { icon: 'undo', title: 'Verrouillage automatique', detail: 'L’app se verrouille après 5 minutes sans utilisation ou 5 minutes ailleurs. Envoyer des CW ou voir tes 12 mots demande toujours Face ID ou ton code.' },
  ] as KeyPoint[],
  webFooter: 'App Web',
  offlineBanner: 'Pas de connexion Internet.',
  unsupportedBrowser: "Ce navigateur est trop ancien pour COINWOW. Mets-le à jour ou utilise Safari, Chrome ou Firefox récent.",
};

export type Strings = typeof fr;

export const en: Strings = {
  ok: "OK",
  cancel: "Cancel",
  done: "Done",
  save: "Save",
  delete: "Delete",
  later: "Later",
  copy: "Copy",
  copied: "Copied",
  share: "Share",
  paste: "Paste",
  clear: "Clear",
  continueButton: "Continue",
  now: "now",
  today: "Today",
  yesterday: "Yesterday",
  language: "Language",
  languageTitle: "Choose your language",
  languageSubtitle: "You can change it at any time in Settings.",
  legalTitle: "Before you start",
  legalSubtitle: "Read these key points. They protect your money.",
  legalUpdatedTitle: "Our terms have changed",
  legalUpdatedSubtitle: "Read the changes and accept them to keep using COINWOW.",
  legalWhatChanged: "What's changing",
  legalUpdateSummary: "Version 1.1: the terms now cover the Android app (Google Play) and explain how your phrase is protected on Android. Nothing changes on iPhone and the web.",
  legalReadFull: "Read the full document",
  legalCheckAge: "I am of legal age where I live (18 in Québec).",
  legalCheckRisk: "I understand that if I lose my recovery phrase my CW are lost forever, that payments are irreversible and that COINWOW guarantees no profit.",
  legalCheckTerms: "I have read and accept the terms of use, the risk disclosure and the privacy policy.",
  legalAcceptButton: "Accept and continue",
  legalDocumentTitle: "Terms and privacy",
  welcomeTagline: "Your CW wallet.\nYour keys stay on your phone.",
  createWallet: "Create a wallet",
  haveWallet: "I already have a wallet",
  restoreTitle: "Restore",
  restoreHeader: "Your 12 or 24 words, separated by spaces",
  restoreSuggestions: "Suggestions",
  restoreButton: "Restore my wallet",
  restoreFooter: "Your words stay on your phone. They are never sent to COINWOW.",
  restoreBadChecksum: "These words don't form a valid phrase. Check the order and each word.",
  restoreInvalid: "Invalid phrase.",
  backupIntroTitle: "Back up your recovery phrase",
  backupShowWords: "Show my 12 words",
  backupWordsTitle: "Your 12 words",
  backupWordsSubtitle: "Write them down on paper, in this exact order.",
  backupNoScreenshot: "No screenshots: a photo can be stolen or synced online.",
  backupWroteThem: "I wrote them down",
  backupScreenshotTitle: "Screenshot detected",
  backupScreenshotMessage: "For your safety, delete this screenshot from Photos and write your words on paper instead.",
  backupVerifyTitle: "Let's check your backup",
  backupWrongWord: "That's not the right word. Check your paper.",
  backupSeeWordsAgain: "See my words again",
  backupDoneTitle: "Backup confirmed",
  backupDoneText: "Keep your paper somewhere safe. It is the only way to recover your CW if you lose your phone.",
  backupReminderTitle: "Back up your phrase",
  backupReminderText: "Without your 12 words, you lose your CW if you lose your phone.",
  backupSettingsRow: "12-word backup",
  fileBackupRow: 'Encrypted backup (file)',
  fileBackupTitle: 'Encrypted backup',
  fileBackupIntro: 'Creates a file that holds your 12 words, encrypted with a password you choose. Keep it in iCloud Drive, Google Drive or on a USB key, then restore it on any COINWOW device.',
  fileBackupWarning: "Nobody can recover this password, not COINWOW and not your cloud provider. If you forget it, the file is useless: keep your paper copy too.",
  fileBackupPassword: 'Backup password',
  fileBackupConfirm: 'Confirm the password',
  fileBackupTooShort: 'At least 10 characters. A passphrase works very well.',
  fileBackupMismatch: "The two passwords don't match.",
  fileBackupCreate: 'Create the file',
  fileBackupWorking: 'Encrypting…',
  fileBackupDone: 'File created. Keep it somewhere safe and write your password down elsewhere.',
  fileBackupRestoreRow: 'Restore from an encrypted file',
  fileBackupChoose: 'Choose the backup file',
  fileBackupRestore: 'Restore from the file',
  fileBackupErrNot: "This file isn't a COINWOW backup.",
  fileBackupErrUnsupported: "This backup comes from a version this app doesn't recognise.",
  fileBackupErrNetwork: 'This backup is for another network.',
  fileBackupErrPassword: 'Wrong password, or the file was modified.',
  fileBackupErrPhrase: 'The file decrypted, but the phrase inside is invalid.',
  backupStatusDone: "Done",
  backupStatusTodo: "To do",
  tabWallet: "Wallet",
  activity: "Activity",
  scan: "Scan",
  settings: "Settings",
  totalBalance: "Total balance",
  showBalance: "Show balance",
  hideBalance: "Hide balance",
  send: "Send",
  receive: "Receive",
  latestTransactions: "Latest transactions",
  noTransactions: "No transactions yet.",
  seeAll: "See all",
  myAddress: "My address",
  copyAddress: "Copy address",
  received: "Received",
  sent: "Sent",
  pending: "Pending",
  confirmed: "Confirmed",
  receiveTitle: "Receive CW",
  receiveOnlyCW: "Only send CW (COINWOW) to this address.",
  receiveNewAddress: "A new address appears after each payment received, to protect your privacy. Old ones remain valid.",
  qrLabel: "Address QR code",
  transaction: "Transaction",
  status: "Status",
  date: "Date",
  block: "Block",
  networkFee: "Network fee",
  subtractFee: "Subtract fee from amount",
  transactionID: "Transaction ID",
  sendTitle: "Send CW",
  to: "To",
  addressPlaceholder: "cw1… address",
  addressInvalid: "This is not a valid COINWOW address. A CW address starts with \"cw1\".",
  addressAmountInvalid: "The amount in this code is invalid.",
  addressUnsupported: "This payment code requires an option COINWOW doesn't support.",
  ownAddressWarning: "This is an address of your own wallet.",
  scanQR: "Scan a QR code",
  amount: "Amount",
  amountInvalid: "Invalid amount (8 decimals maximum).",
  fees: "Fees",
  speed: "Speed",
  feeSlow: "Economy",
  feeNormal: "Normal",
  feeFast: "Fast",
  feesFooter: "Fees go to COINWOW network miners, not to the app.",
  reviewSend: "Review payment",
  review: "Review",
  youSend: "You send",
  totalDebited: "Total debited",
  irreversibleWarning: "Double-check the address. A blockchain payment cannot be cancelled.",
  confirmSend: "Confirm payment",
  sentTitle: "Sent",
  copyTxid: "Copy transaction ID",
  txidCopied: "ID copied",
  addToContacts: "Add to contacts",
  scanTitle: "Scan",
  scanHint: "Point at a COINWOW address QR code",
  scanNoCamera: "No camera on this device. Paste the address in the Send screen.",
  scanNotCoinwow: "This QR code doesn't contain a COINWOW address.",
  openSettings: "Open Settings",
  contactsTitle: "Contacts",
  contactsEmpty: "No contacts. Add your friends so you never have to retype their address.",
  contactsSearch: "Search",
  contactAdd: "Add a contact",
  contactNew: "New contact",
  contactEdit: "Edit contact",
  contactName: "Name",
  contactNamePlaceholder: "Contact name",
  contactAddress: "COINWOW address",
  contactDelete: "Delete contact",
  securityBackup: "Security",
  showPhrase: "Show my recovery phrase",
  hidePhrase: "Hide phrase",
  phraseWarning: "Write these words on paper, in order. Anyone who sees them can take your CW.",
  network: "Network",
  server: "Server",
  about: "About",
  version: "Version",
  deleteWallet: "Delete the wallet from this device",
  deleteWalletFooter: "Your CW stay on the blockchain. You can only recover them with your 12 words.",
  deleteWalletConfirm: "Without your 12-word phrase, you won't be able to recover your CW.",
  authShowPhrase: "Show your recovery phrase",
  authDeleteWallet: "Delete the wallet from this device",
  usePasscode: "Use passcode",
  authUnlock: "Unlock COINWOW",
  unlock: "Unlock",
  notifPendingBody: "The payment is on its way and will be confirmed in the next block.",
  notifConfirmedBody: "The payment is confirmed.",
  rateLimited: "Too many requests. Try again in a few seconds.",
  invalidResponse: "Unexpected response from the COINWOW server.",
  inconsistentData: "The server returned inconsistent data. For your safety, nothing was shown.",
  genericError: "Something went wrong. Please try again.",
  legalAcceptedOn: (date: string) => `Accepted on this device on ${date}.`,
  restoreWordCount: (n: number) => n == 1 ? `1 word` : `${n} words`,
  restoreUnknownWord: (word: string) => `"${word}" is not a word from the list. Check the spelling.`,
  restoreBadCount: (n: number) => `You need 12 or 24 words (you have ${n}).`,
  backupVerifySubtitle: (current: number, total: number) => `Pick the right word from your paper (${current} of ${total}).`,
  backupWordNumber: (n: number) => `Word #${n}`,
  pendingAmount: (amount: string) => `${amount} pending`,
  confirmations: (n: number) => n == 1 ? `Confirmed (1 confirmation)` : `Confirmed (${n} confirmations)`,
  available: (amount: string) => `Available: ${amount}`,
  sentText: (amount: string) => `${amount} is on its way. It will be confirmed in the next block.`,
  contactDeleteConfirm: (name: string) => `Delete "${name}" from your contacts?`,
  contactDuplicate: (name: string) => `This address is already saved for "${name}".`,
  authSend: (amount: string) => `Confirm sending ${amount}`,
  notifReceivedTitle: (amount: string) => `You received ${amount}`,
  txRejected: (reason: string) => `Transaction rejected by the network: ${reason}`,
  serverError: (status: number) => `COINWOW server error (${status}). Try again later.`,
  offline: (detail: string) => `Can't reach the COINWOW server. Check your Internet connection. (${detail})`,
  amountBelowDust: (minimum: string) => `Amount too small. Minimum: ${minimum}.`,
  insufficientFunds: (needed: string, available: string) => `Insufficient balance: you need ${needed} including fees, you have ${available}.`,
  feeTooHigh: (fee: string) => `Unusually high fee (${fee}). Payment blocked for your safety.`,
  legalKeyPoints: [
    { icon: 'key', title: 'Only you control your CW', detail: 'COINWOW is a non-custodial wallet. We never have access to your funds and cannot block or recover them.' },
    { icon: 'warning', title: 'Lose your phrase = lose your CW', detail: 'Your 12 words are the only key to your wallet. Without them, nobody can recover your CW, not even us.' },
    { icon: 'undo', title: 'Payments are irreversible', detail: 'A confirmed payment cannot be cancelled. Always check the address and amount.' },
    { icon: 'chart', title: 'No guarantee of profit', detail: 'CW is an experimental cryptocurrency, not an investment. Its value can drop to zero. COINWOW will not make you rich.' },
    { icon: 'shield', title: 'We will never ask for your 12 words', detail: "Anyone asking for them, even in COINWOW's name, is trying to steal from you. Beware of fake sites and scams." },
    { icon: 'person', title: 'Adults only', detail: "You must be of legal age where you live (18 in Québec) and follow your country's laws, including tax laws." },
    { icon: 'hand', title: 'Your privacy', detail: 'No name, email or phone number required. No ads, no tracking. The blockchain itself is public.' },
  ] as KeyPoint[],
  backupIntroPoints: [
    'You will see 12 words. Write them down on paper, in order.',
    'With these words, you can recover your CW on any device.',
    "Keep the paper somewhere safe. Don't photograph it or share it with anyone.",
    'On the web, your browser may erase its data: your paper is your only real backup.',
  ],

  // --- Web ---
  iCloudFooter: 'Your phrase is encrypted with your passcode and stays only in this browser. It is not backed up anywhere else: keep your paper copy.',
  scanCameraDenied: "COINWOW can't access the camera. Allow it in your browser settings, then try again.",
  keychainError: (status: number) => `Storage error (${status}).`,
  backupMandatoryNote: 'On the web this step is required: your browser may erase its data without warning.',
  pinCreateTitle: 'Choose a passcode',
  pinCreateSubtitle: '6 digits to open COINWOW and confirm your payments. It encrypts your phrase on this device.',
  pinConfirmTitle: 'Confirm your passcode',
  pinMismatch: "The two passcodes don't match. Try again.",
  pinWeak: 'Passcode too simple. Avoid 000000, 123456 and sequences.',
  pinEnterTitle: 'Enter your passcode',
  pinWrong: (left: number) => left > 0 ? `Wrong passcode. ${left} more ${left > 1 ? 'tries' : 'try'} before a pause.` : 'Wrong passcode.',
  pinLocked: (seconds: number) => `Too many tries. Try again in ${seconds} s.`,
  pinForgot: 'Forgot your passcode?',
  pinForgotText: 'Without your passcode, the only way to get your CW back is your 12-word phrase: delete the wallet from this browser, then restore it with your phrase and choose a new passcode.',
  pinReset: 'Delete and restore',
  confirmWithPin: 'Confirm with your passcode',
  unlockFaceID: 'Use Face ID',
  faceIDOfferTitle: 'Open COINWOW with Face ID?',
  faceIDOfferText: 'Faster than your passcode. Your passcode always keeps working, and Face ID never leaves your device.',
  faceIDOfferButton: 'Turn on Face ID',
  faceIDConfirm: 'Confirm with Face ID',
  faceIDRow: 'Face ID / Touch ID',
  faceIDFooter: 'Unlock with Face ID or Touch ID using a passkey. Your passcode always keeps working.',
  faceIDUnsupported: 'Not available in this browser. Add COINWOW to your Home Screen on a recent device.',
  faceIDFailed: "Face ID didn't work. Use your passcode.",
  enable: 'Turn on',
  disable: 'Turn off',
  installTitle: 'Add COINWOW to your Home Screen',
  installText: 'COINWOW then opens like a real app, full screen, and your browser keeps its data more reliably.',
  installStepsIOS: ['Tap the Share button (the square with an arrow) in Safari.', 'Choose "Add to Home Screen".', 'Tap "Add".'],
  installStepsOther: ["Open your browser's menu (⋮).", 'Choose "Install app" or "Add to Home screen".'],
  installFirstTitle: 'Install COINWOW as an app',
  installFirstText: 'Add COINWOW to your Home Screen before you start: it opens full screen, with Face ID, and your wallet stays in one place.',
  installIPhoneTitle: 'iPhone (Safari)',
  installIPhoneSteps: ['Open app.coinwow.ca in Safari.', 'Tap the Share button (the square with an arrow). On iOS 26, it is in the ⋯ menu next to the address.', 'Choose "Add to Home Screen", then "Add".', 'Open COINWOW from your Home Screen and create your wallet there.'],
  installAndroidTitle: 'Android (Chrome)',
  installAndroidSteps: ['Open app.coinwow.ca in Chrome.', 'Tap the ⋮ menu at the top right.', 'Choose "Install app" or "Add to Home screen", then confirm.', 'Open COINWOW from your Home Screen.'],
  installNow: 'Install now',
  installLater: 'Continue in the browser',
  installIOSNote: 'On iPhone, do it before creating or restoring your wallet: the Home Screen app has its own storage, separate from Safari.',
  installRow: 'Install on the Home Screen',
  notifications: 'Notifications',
  notificationsRow: 'Tell me when I receive CW',
  notificationsFooter: 'Works while COINWOW is open. On iPhone, first add COINWOW to your Home Screen (iOS 16.4 or later).',
  notificationsDenied: 'Notifications are blocked in your browser settings.',
  exportCoreRow: 'Export to COINWOW Core',
  exportCoreTitle: 'Export to COINWOW Core',
  exportCoreText: 'To recover your CW without our servers, paste these two commands in the COINWOW Core console (Window → Console), in an empty wallet created for this purpose.',
  exportCoreWarning: 'These lines contain your private key: anyone who sees them can take your CW. Never share them.',
  copyCommand: 'Copy command',
  storageWarning: 'This browser may erase COINWOW data. Keep your 12-word phrase on paper.',
  webWarningsTitle: 'Good to know',
  webWarningsIntro: 'COINWOW Web keeps your wallet only in this browser, on this device. Read these points before putting money in it.',
  webWarningsRow: 'Things to know about the web app',
  webWarningsAccept: 'I understand',
  webWarnings: [
    { icon: 'key', title: 'Your 12 words are your only backup', detail: 'The wallet lives only in this browser. If you clear Safari’s history, change phones or remove the app from your Home Screen, it is gone. Without your 12 words on paper, your CW are lost forever.' },
    { icon: 'warning', title: 'On iPhone: Safari and the Home Screen are separate', detail: 'The app added to the Home Screen has its own storage. A wallet created in Safari does not show up there (and the other way around): restore it with your 12 words.' },
    { icon: 'shield', title: 'Choose a hard passcode', detail: 'Your wallet is encrypted with your passcode. Someone who copies your device’s data could try to guess it: avoid 123456, your birthday or a code you use elsewhere.' },
    { icon: 'chart', title: 'Keep small amounts', detail: 'A browser is less protected than an installed app or an offline computer. For large amounts, use COINWOW Core.' },
    { icon: 'person', title: 'Beware of fake sites', detail: 'The only official address is app.coinwow.ca. Nobody from COINWOW will ever ask for your 12 words or your passcode.' },
    { icon: 'undo', title: 'Automatic lock', detail: 'The app locks after 5 minutes without use or 5 minutes away. Sending CW or showing your 12 words always asks for Face ID or your passcode.' },
  ] as KeyPoint[],
  webFooter: 'Web app',
  offlineBanner: 'No Internet connection.',
  unsupportedBrowser: 'This browser is too old for COINWOW. Update it or use a recent Safari, Chrome or Firefox.',
};
